<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main lr" id="mlrp">
                <div class="row nav-top">
                    <div class="col-8 ddavc"><span class="nav-back wt" id="back" onclick="window.location.href='#/login'"></span><span
                            class="tfw-5 tf-18" id="navNam">Forgot Password?</span></div>
                </div>
                <div class="row">
                    <div class="col-12 pt-4 xtc" id="cimg"><img src="../assets/logo.png" height="170"></div>
                    <div class="col-12" id="vrgj89b">
                        <div class="row">
                            <div class="col-12">
                                <div class="row mr-0 pt-1">
                                    <div class="col-12 inpbcx"><span class="xicon cell"></span> <input type="tel"
                                            class="xbox" oninput="lnxG()" id="emob" maxlength="10"
                                            placeholder="Enter Mobile Number" autocomplete="off" onkeydown="lgenk()">
                                    </div>
                                    <div class="col-12 inpbcx" id="elpsh78" style=""><span class="xicon lock"></span>
                                        <input class="xbox pin" oninput="lnxG()" id="epass" maxlength="21"
                                            placeholder="New Password (≥6 characters)" autocomplete="off"
                                            onkeydown="lgenk()"></div>
                                    <div class="col-12 pa-0 xtl dipn" id="ero89bj" style="display: block;">
                                        <div class="inpbcx"><span class="xicon key"></span> <input type="tel"
                                                class="xbox" oninput="lnxG()" id="eotp" maxlength="6"
                                                placeholder="Verification Code" autocomplete="off" onkeydown="lgenk()">
                                            <span class="GOTP" onclick="GOTP()" id="GOTP">OTP</span></div>
                                    </div>
                                    <div class="col-12 pa-0 pt-1 ml-2 mb-2 tfcdb tf-16 xtl" id="remmc"
                                        style="display: none;"><span class="dipn"><input type="checkbox" id="ccbox"
                                                checked=""></span> <span class="tfcsdb dipn">Remeber Me</span></div>
                                    <div class="col-12 pa-0 mt-2 mb-3">
                                        <div class="btn-main" id="lnxG">Reset</div>
                                    </div>
                                    <div class="col-6 tf-18 pa-0 mt-2 mb-2" id="canac" style="display: none;">
                                        <div class="mcpl srm67b" onclick="srm67b()">Create an account</div>
                                    </div>
                                    <div class="col-6 xtr pt-2 pb-2 pr-0" id="qlt">
                                        <div class="mcpl srm67b ldr" id="vgh79" onclick="qlt()">Forgot Password?</div>
                                        <div class="tln" id="hlbb"><span class="lrtbln"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "ForgotView",
    data() {
        return {
            countDown: 180,
            otpactive: true,
            user: {
                username: null,
                password: null,
                code: null,

            }
        }
    },
    mounted: function () {
       
    },
    methods: {
       
        pop(message) {
            document.getElementById("snackbar").innerHTML = message;
            document.getElementById("snackbar").style.display = "";
            setTimeout(function () { document.getElementById("snackbar").style.display = "none"; }, 3000);
        },
        onRegister() {
            if (this.user.username == null || this.user.password == null || this.user.code == null) {
                if (this.user.username == null) {
                    this.pop("Mobile number is requied")
                } else if (this.user.password == null) {
                    this.pop("Password is requied")
                } else if (this.user.code == null) {
                    this.pop("Verfication Code is requied")
                }

            } else {
                var data = new FormData();
                data.append("username", this.user.username.substring(3));
                data.append("password", this.user.password);
                data.append("code", this.user.code);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=reset",
                        data
                    )
                    .then(res => {
                        if (res.data[0].status == "success") {
                            this.pop(res.data[0].status);
                            console.log("Success", res.data[0].status);
                            setTimeout(() => { this.$router.push("/login"); }, 600);
                        } else {
                            console.log("Error", res.data);
                            this.pop(res.data[0].status);
                        }
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
            }
        },
        countDownTimer() {
            this.otpactive = false;
            document.getElementById("otpbtn").innerHTML = "WAIT" + " " + this.countDown + "s";
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                document.getElementById("otpbtn").innerHTML = "RESEND";
                this.otpactive = true;
            }
        },
        otp() {
            if (this.user.username != null) {
                if (this.otpactive == true) {
                    document.getElementById("otpbtn").className = "gocode_time";
                    axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/otp.php?num=' + this.user.username.substring(3));
                    this.pop("Success");
                    this.countDownTimer();
                }

            } else {
                this.pop("Mobile number is requied")
            }

        },
        num() {
            document.getElementById("numactive").style.display = "";
            document.getElementById("numunactive").style.display = "none";
            if (document.getElementById("username").value == "") {
                document.getElementById("username").value = "+91";
            }
        },
        numout() {
            document.getElementById("numactive").style.display = "none";
            document.getElementById("numunactive").style.display = "";
        },
        pass() {
            document.getElementById("passactive").style.display = "";
            document.getElementById("passerror").style.display = "none";
            document.getElementById("passerrortxt").style.display = "none";
            document.getElementById("passunactive").style.display = "none";
        },
        passout() {
            if (this.user.password == null) {
                document.getElementById("passactive").style.display = "none";
                document.getElementById("passunactive").style.display = "none";
                document.getElementById("passerror").style.display = "";
                document.getElementById("passerrortxt").style.display = "";
            } else {
                document.getElementById("passactive").style.display = "none";
                document.getElementById("passunactive").style.display = "";
            }
        },
        code() {
            document.getElementById("codeactive").style.display = "";
            document.getElementById("codeerror").style.display = "none";
            document.getElementById("codeerrortxt").style.display = "none";
            document.getElementById("codeunactive").style.display = "none";
        },
        codeout() {
            if (this.user.code == null) {
                document.getElementById("codeactive").style.display = "none";
                document.getElementById("codeunactive").style.display = "none";
                document.getElementById("codeerror").style.display = "";
                document.getElementById("codeerrortxt").style.display = "";
            } else {
                document.getElementById("codeactive").style.display = "none";
                document.getElementById("codeunactive").style.display = "";
            }
        }
    }
}
</script>